// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "path[data-v-66f9aeb9] {\n  fill: currentColor;\n}", ""]);
// Exports
module.exports = exports;
